/** Main server base URL. Empty in dev = CRA proxy → localhost:5001 */
export function getApiBaseUrl() {
    const fromEnv = process.env.REACT_APP_API_URL?.trim();
    if (fromEnv) return fromEnv;
    return process.env.NODE_ENV === "development" ? "" : "http://localhost:5001";
}